import React from 'react';

const PLACEHOLDER_COLORS = [
  ['#F4ECD8', '#C8A96E'],
  ['#E8F0E8', '#7BA97B'],
  ['#F0E8F0', '#A07BA0'],
  ['#E8EEF8', '#7B93C8'],
  ['#F8EDE8', '#C87B5A'],
  ['#E8F4F4', '#5AA8A8'],
  ['#F4F0E8', '#A89B6E'],
  ['#EEE8F8', '#8B7BC8'],
];

function getPlaceholderStyle(index) {
  const colors = PLACEHOLDER_COLORS[index % PLACEHOLDER_COLORS.length];
  return { background: colors[0], iconColor: colors[1] };
}

export default function MenuCard({ menu, onSelect, onAdd, seniorMode, index = 0 }) {
  const isSoldOut = menu.soldOut || menu.isSoldOut || menu.is_sold_out === 1 || menu.is_sold_out === true || menu.status === 'soldout';
  const isPopular = menu.isPopular || menu.is_popular === 1 || menu.is_popular === true;
  const isNew = menu.isNew || menu.is_new === 1 || menu.is_new === true;
  const ph = getPlaceholderStyle(index);

  return (
    <div
      className={`menu-item ${isSoldOut ? 'sold-out' : ''}`}
      onClick={() => !isSoldOut && onSelect(menu)}
    >
      {/* Left: info */}
      <div className="menu-item-info">
        {(isPopular || isNew || isSoldOut) && (
          <div style={{ display: 'flex', gap: 5, marginBottom: 6, flexWrap: 'wrap' }}>
            {!isSoldOut && isPopular && (
              <span className="menu-badge menu-badge-popular">인기</span>
            )}
            {isNew && (
              <span className="menu-badge menu-badge-new">NEW</span>
            )}
            {isSoldOut && (
              <span className="menu-badge menu-badge-soldout">품절</span>
            )}
          </div>
        )}

        <div className="menu-item-name" style={{ fontSize: seniorMode ? 18 : 16 }}>
          {menu.name}
        </div>
        {menu.description && (
          <div className="menu-item-desc" style={{ fontSize: seniorMode ? 14 : 13 }}>
            {menu.description}
          </div>
        )}
        <div className="menu-item-price" style={{ fontSize: seniorMode ? 17 : 15 }}>
          {(menu.price || 0).toLocaleString()}
          <span style={{ fontSize: '0.8em', fontWeight: 600, marginLeft: 1 }}>원</span>
        </div>
      </div>

      {/* Right: image + add button */}
      <div className="menu-item-right">
        <div
          className="menu-item-thumb"
          style={{ width: seniorMode ? 80 : 88, height: seniorMode ? 80 : 88 }}
        >
          {(menu.imageUrl || menu.image_url) ? (
            <img
              src={menu.imageUrl || menu.image_url}
              alt={menu.name}
              onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
            />
          ) : null}
          <div
            style={{
              display: (menu.imageUrl || menu.image_url) ? 'none' : 'flex',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              background: ph.background,
              borderRadius: 'var(--radius-md)',
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={ph.iconColor} strokeWidth="1.5" strokeLinecap="round">
              <path d="M18 8h1a4 4 0 0 1 0 8h-1"/>
              <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/>
              <line x1="6" y1="1" x2="6" y2="4"/>
              <line x1="10" y1="1" x2="10" y2="4"/>
              <line x1="14" y1="1" x2="14" y2="4"/>
            </svg>
          </div>
          {isSoldOut && (
            <div className="menu-item-soldout-overlay">
              <span>품절</span>
            </div>
          )}
        </div>
        {!isSoldOut && (
          <button
            className="menu-add-btn"
            onClick={(e) => {
              e.stopPropagation();
              onAdd(menu);
            }}
            style={{ width: seniorMode ? 36 : 32, height: seniorMode ? 36 : 32 }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
